<div class="flex flex-row justify-center items-center content-center" class="profile-container">
  <div class="basis-6/12 md:basis-9/12 sm:basis-10/12 xs:basis-11/12" class="profile-wrapper">
    <span class="close" (click)="close()"><mat-icon>close</mat-icon></span>
    <div class="flex flex-col justify-center items-center content-center">
      <img class="logo" src="../../../../assets/images/logo-img.svg" />
      <h1 mat-dialog-title translate>PRIVACYVERKLARING BEEFUND</h1>
    </div>
    <div class="text">
      <p><strong>{{ 'TRADE_NAME' | translate }}</strong></p>
      <p>{{ 'ADDRESS' | translate }}</p>
      <p>{{ 'CHAMBER_COMMERCE' | translate }}</p>
      <p>{{ 'LAST_UPDATED' | translate }}</p>
      <p>{{ 'BEEFUND_DESCRIPTION' | translate }}</p>
      <p>{{ 'PRIVACY_STATEMENT_INTRO' | translate }}</p>
      <p>{{ 'PERSONAL_DATA_USAGE' | translate }}</p>
      <h3>{{ 'DEFINITIONS_TITLE' | translate }}</h3>
      <p>{{ 'DEFINITIONS_INTRO' | translate }}</p>
      <p><strong>{{ 'DEFINITION_SERVICES' | translate }}</strong></p>
      <p><strong>{{ 'DEFINITION_USAGE_DATA' | translate }}</strong></p>
      <p><strong>{{ 'DEFINITION_DATA_CONTROLLER' | translate }}</strong></p>
      <p><strong>{{ 'DEFINITION_DATA_PROCESSORS' | translate }}</strong></p>
      <p><strong>{{ 'DEFINITION_SUBJECT' | translate }}</strong></p>
      <p><strong>{{ 'DEFINITION_PERSONAL_DATA' | translate }}</strong></p>
      <p><strong>{{ 'DEFINITION_AGREEMENT' | translate }}</strong></p>
      
      <h3>{{ 'DATA_COLLECTION_AND_USE' | translate }}</h3>
      <p>{{ 'DATA_COLLECTION_DESCRIPTION' | translate }}</p>
      <p>{{ 'DATA_COLLECTION_ABUSE' | translate }}</p>
      <strong>{{ 'PERSONAL_DATA' | translate }}</strong>
      <p>{{ 'PERSONAL_DATA_DESCRIPTION' | translate }}</p>
      <div class="table" class="flex flex-col justify-left items-left content-left">
        <div class="table-row header flex flex-row justify-left items-left content-left">
          <div class="basis-1/3"><strong>{{ 'PERSONAL_DATA' | translate }}</strong></div>
          <div class="basis-2/3"><strong>{{ 'PROCESSING_PURPOSES' | translate }}</strong></div>
        </div>
        <div class="table-row flex flex-row justify-left items-left content-left">
          <div class="basis-1/3">{{ 'FULL_NAME' | translate }}</div>
          <div class="basis-2/3">
            <ul>
              <li>{{ 'EXECUTE_AGREEMENT' | translate }}</li>
              <li>{{ 'PARTIAL_REFUND' | translate }}</li>
              <li>{{ 'SERVICE_COMMUNICATION' | translate }}</li>
              <li>{{ 'SEND_NEWSLETTERS' | translate }}</li>
            </ul>
          </div>
        </div>
        <div class="table-row flex flex-row justify-left items-left content-left">
          <div class="basis-1/3">{{ 'IBAN' | translate }}</div>
          <div class="basis-2/3">{{ 'IBAN_PURPOSE' | translate }}</div>
        </div>
        <div class="table-row flex flex-row justify-left items-left content-left">
          <div class="basis-1/3">{{ 'ADDRESS_TITLE' | translate }}</div>
          <div class="basis-2/3">{{ 'ADDRESS_PURPOSE' | translate }}</div>
        </div>
        <div class="table-row flex flex-row justify-left items-left content-left">
          <div class="basis-1/3">{{ 'EMAIL' | translate }}</div>
          <div class="basis-2/3">
            <ul>
              <li>{{ 'CONFIRMATION_EMAIL' | translate }}</li>
              <li>{{ 'SEND_PROMOTIONAL_EMAILS' | translate }}</li>
            </ul>
          </div>
        </div>
        <div class="table-row flex flex-row justify-left items-left content-left">
          <div class="basis-1/3">{{ 'DOB' | translate }}</div>
          <div class="basis-2/3">{{ 'DOB_PURPOSE' | translate }}</div>
        </div>
        <div class="table-row flex flex-row justify-left items-left content-left">
          <div class="basis-1/3">{{ 'GENDER' | translate }}</div>
          <div class="basis-2/3">{{ 'GENDER_PURPOSE' | translate }}</div>
        </div>
        <div class="table-row flex flex-row justify-left items-left content-left">
          <div class="basis-1/3">{{ 'IP_ADDRESS' | translate }}</div>
          <div class="basis-2/3">
            <ul>
              <li>{{ 'WEB_STATS' | translate }}</li>
              <li>{{ 'UNIQUE_PARTICIPATION_CHECK' | translate }}</li>
            </ul>
          </div>
        </div>
      </div>

      <strong>{{ 'USAGE_DATA' | translate }}</strong>
      <p>{{ 'USAGE_DATA_PARAGRAPH' | translate }}</p>

      <p>{{ 'USAGE_DATA_PURPOSE' | translate }}</p>
      <ul>
        <li>{{ 'COLLECT_ANALYSIS_DATA' | translate }}</li>
        <li>{{ 'DETECT_TECH_ISSUES' | translate }}</li>
      </ul>

      <strong>{{ 'NEWSLETTER' | translate }}</strong>
      <p>{{ 'NEWSLETTER_USAGE' | translate }}</p>

      <h3>{{ 'LEGAL_BASIS' | translate }}</h3>
      <p>{{ 'LEGAL_BASIS_P1' | translate }}</p>

      <p>{{ 'PERSONAL_DATA_USAGE_REASON' | translate }}</p>
      <ul>
        <li>{{ 'CONTRACT_REASON' | translate }}</li>
        <li>{{ 'CONSENT_REASON' | translate }}</li>
        <li>{{ 'LEGITIMATE_INTEREST_REASON' | translate }}</li>
        <li>{{ 'LAW_COMPLIANCE_REASON' | translate }}</li>
      </ul>

      <h3>{{ 'STORAGE_AND_RETENTION' | translate }}</h3>
      <p>{{ 'STORAGE_AND_RETENTION_P1' | translate }}</p>
      <p>{{ 'STORAGE_AND_RETENTION_P2' | translate }}</p>
      <p>{{ 'STORAGE_AND_RETENTION_P3' | translate }}</p>
      <p>{{ 'STORAGE_AND_RETENTION_P4' | translate }}</p>

      <h3>{{ 'DATA_DISCLOSURE' | translate }}</h3>
      <h4>{{ 'BUSINESS_TRANSACTION' | translate }}</h4>
      <p>{{ 'BUSINESS_TRANSACTION_P1' | translate }}</p>

      <h4>{{ 'LAW_ENFORCEMENT_DISCLOSURE' | translate }}</h4>
      <p>{{ 'LAW_ENFORCEMENT_DISCLOSURE_P1' | translate }}</p>

      <h4>{{ 'LEGAL_REQUIREMENTS' | translate }}</h4>
      <p>{{ 'LEGAL_REQUIREMENTS_P1' | translate }}</p>
      <ul>
        <li>{{ 'LEGAL_REQUIREMENTS_REASON1' | translate }}</li>
        <li>{{ 'LEGAL_REQUIREMENTS_REASON2' | translate }}</li>
        <li>{{ 'LEGAL_REQUIREMENTS_REASON3' | translate }}</li>
        <li>{{ 'LEGAL_REQUIREMENTS_REASON4' | translate }}</li>
        <li>{{ 'LEGAL_REQUIREMENTS_REASON5' | translate }}</li>
      </ul>

      <h3>{{ 'DATA_SECURITY' | translate }}</h3>
      <p>{{ 'DATA_SECURITY_P1' | translate }}</p>

      <h3>{{ 'YOUR_DATA_PROTECTION_RIGHTS' | translate }}</h3>
      <p>{{ 'YOUR_DATA_PROTECTION_RIGHTS_P1' | translate }}</p>
      <p>{{ 'YOUR_DATA_PROTECTION_RIGHTS_P2' | translate }}</p>
      <p>{{ 'YOUR_DATA_PROTECTION_RIGHTS_P3' | translate }}</p>
      <ul>
        <li>{{ 'DATA_PROTECTION_RIGHT1' | translate }}</li>
        <li>{{ 'DATA_PROTECTION_RIGHT2' | translate }}</li>
        <li>{{ 'DATA_PROTECTION_RIGHT3' | translate }}</li>
        <li>{{ 'DATA_PROTECTION_RIGHT4' | translate }}</li>
        <li>{{ 'DATA_PROTECTION_RIGHT5' | translate }}</li>
        <li>{{ 'DATA_PROTECTION_RIGHT6' | translate }}</li>
      </ul>
      <p>{{ 'IDENTITY_VERIFICATION' | translate }}</p>
      <p>{{ 'DATA_PROTECTION_COMPLAINT' | translate }}</p>

      <h3>{{ 'SHARING_PERSONAL_DATA' | translate }}</h3>
      <p>{{ 'SHARING_PERSONAL_DATA_P1' | translate }}</p>
      <p>{{ 'SHARING_PERSONAL_DATA_P2' | translate }}</p>

      <div class="table flex flex-col justify-left items-left content-left">
        <div class="table-row header flex flex-row justify-left items-left content-left">
          <div class="basis-1/3"><strong>{{ 'DATA_PROCESSOR' | translate }}</strong></div>
          <div class="basis-2/3"><strong>{{ 'PURPOSE' | translate }}</strong></div>
        </div>
        <div class="table-row flex flex-row justify-left items-left content-left">
          <div class="basis-1/3">{{ 'MICROSOFT' | translate }}</div>
          <div class="basis-2/3">{{ 'MICROSOFT_PURPOSE' | translate }}</div>
        </div>
        <div class="table-row flex flex-row justify-left items-left content-left">
          <div class="basis-1/3">{{ 'MAILCHIMP' | translate }}</div>
          <div class="basis-2/3">{{ 'MAILCHIMP_PURPOSE' | translate }}</div>
        </div>
        <div class="table-row flex flex-row justify-left items-left content-left">
          <div class="basis-1/3">{{ 'ING' | translate }}</div>
          <div class="basis-2/3">{{ 'ING_PURPOSE' | translate }}</div>
        </div>
        <div class="table-row flex flex-row justify-left items-left content-left">
          <div class="basis-1/3">{{ 'GOOGLE' | translate }}</div>
          <div class="basis-2/3">{{ 'GOOGLE_PURPOSE' | translate }}</div>
        </div>
        <div class="table-row flex flex-row justify-left items-left content-left">
          <div class="basis-1/3">{{ 'OTHER_SERVICE_PROVIDERS' | translate }}</div>
          <div class="basis-2/3">{{ 'OTHER_SERVICE_PROVIDERS_PURPOSE' | translate }}</div>
        </div>
      </div>

      <p>{{ 'NO_SELLING_PDATA' | translate }}</p>

      <h3>{{ 'SOCIAL_MEDIA_AND_LINKS' | translate }}</h3>
      <strong>{{ 'SOCIAL_MEDIA' | translate }}</strong>
      <p>{{ 'SOCIAL_MEDIA_P1' | translate }}</p>
      <p>{{ 'SOCIAL_MEDIA_P2' | translate }}</p>

      <strong>{{ 'LINKS_TO_OTHER_WEBSITES' | translate }}</strong>
      <p>{{ 'LINKS_TO_OTHER_WEBSITES_P1' | translate }}</p>

      <h3>{{ 'CHANGES_TO_THIS_PRIVACY_POLICY' | translate }}</h3>
      <p>{{ 'CHANGES_TO_THIS_PRIVACY_POLICY_P1' | translate }}</p>

      <h3>{{ 'CONTACT_US' | translate }}</h3>
      <p>{{ 'CONTACT_US_P1' | translate }}</p>

    </div>
    <div class="flex flex-row justify-center items-center content-center" class="margin-top-20">
      <button mat-raised-button color="accent" (click)="close()">Sluiten</button>
    </div>
  </div>
</div>
